import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { CountryEntity } from './country.entity'

export class CountriesRepository extends BaseRepository<CountryEntity[]> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/countries', token, cache)
    }
}
